// extracted by mini-css-extract-plugin
export default {"container":"_b7Gj","active":"cwnNL","logo":"XfLxI","fallback-title":"u81J7","fallbackTitle":"u81J7"};